export default function HeatBand(props) {
  const data = props.data || [];
  const max = Math.max(...data, 1);

  function getColor(v) {
    var pct = v / max;

    // 🎯 Softer red ↔ green scale
    var r = Math.floor(180 + pct * 60);       // 180 → 240
    var g = Math.floor(180 + (1 - pct) * 60); // 180 → 240

    // 👉 muted base (less contrast)
    return "rgba(" + r + "," + g + ",140,0.65)";
  }

  return (
    <div style={{
      display: "flex",
      width: "100%",
      height: 12,              // 🔥 thinner
      borderRadius: 4,
      overflow: "hidden",
      opacity: 0.85            // 🔥 soften whole band
    }}>
      {data.map(function (v, i) {
        return (
          <div
            key={i}
            style={{
              flex: 1,
              background: getColor(v)
            }}
          />
        );
      })}
    </div>
  );
}